/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPhoneNumberForVerification_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly phoneNumber: string | null, readonly smsConsentGivenAt: any | null };

export type GetPhoneNumberForVerification_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly authorizedSigner: GetPhoneNumberForVerification_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null };

export type GetPhoneNumberForVerification_Query = { readonly __typename: 'Query', readonly creditApplication: GetPhoneNumberForVerification_creditApplication_CreditApplication | null };


export type GetPhoneNumberForVerificationVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetPhoneNumberForVerification = GetPhoneNumberForVerification_Query;


export const GetPhoneNumberForVerificationDocument = gql`
    query GetPhoneNumberForVerification($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    authorizedSigner {
      id
      phoneNumber
      smsConsentGivenAt
    }
  }
}
    `;

/**
 * __useGetPhoneNumberForVerification__
 *
 * To run a query within a React component, call `useGetPhoneNumberForVerification` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneNumberForVerification` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneNumberForVerification({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetPhoneNumberForVerification(baseOptions: Apollo.QueryHookOptions<GetPhoneNumberForVerification, GetPhoneNumberForVerificationVariables> & ({ variables: GetPhoneNumberForVerificationVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhoneNumberForVerification, GetPhoneNumberForVerificationVariables>(GetPhoneNumberForVerificationDocument, options);
      }
export function useGetPhoneNumberForVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhoneNumberForVerification, GetPhoneNumberForVerificationVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhoneNumberForVerification, GetPhoneNumberForVerificationVariables>(GetPhoneNumberForVerificationDocument, options);
        }
export function useGetPhoneNumberForVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhoneNumberForVerification, GetPhoneNumberForVerificationVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPhoneNumberForVerification, GetPhoneNumberForVerificationVariables>(GetPhoneNumberForVerificationDocument, options);
        }
export type GetPhoneNumberForVerificationHookResult = ReturnType<typeof useGetPhoneNumberForVerification>;
export type GetPhoneNumberForVerificationLazyQueryHookResult = ReturnType<typeof useGetPhoneNumberForVerificationLazyQuery>;
export type GetPhoneNumberForVerificationSuspenseQueryHookResult = ReturnType<typeof useGetPhoneNumberForVerificationSuspenseQuery>;
export type GetPhoneNumberForVerificationQueryResult = Apollo.QueryResult<GetPhoneNumberForVerification, GetPhoneNumberForVerificationVariables>;